import { DynamicIcon, iconNames } from 'lucide-react/dynamic';
import { Badge, Card } from 'react-bootstrap';
import { type InventoryItem } from '../../service/api';

interface InventoryCardProps {
  item: InventoryItem;
  onActivate?: (item: InventoryItem) => void;
  size?: 'sm' | 'md' | 'lg';
}

export function InventoryCard({
  item,
  onActivate,
  size = 'sm',
}: InventoryCardProps) {
  const sizeConfig = {
    sm: { container: '3rem', icon: 32 },
    md: { container: '4rem', icon: 48 },
    lg: { container: '5rem', icon: 64 },
  };

  const config = sizeConfig[size];

  const handleActivate = () => {
    if (onActivate && item.status === 'available' && item.amount > 0) {
      onActivate(item);
    }
  };

  return (
    <Card
      className="h-100 text-white mb-2"
      onClick={handleActivate}
      style={{ backgroundColor: 'rgba(6, 56, 96, 0.85)', cursor: 'pointer' }}
    >
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {item.item.icon && iconNames.includes(item.item.icon) && (
              <div
                className="d-flex align-items-center justify-content-center rounded-3 bg-primary me-2"
                style={{
                  width: config.container,
                  height: config.container,
                }}
              >
                <DynamicIcon
                  name={item.item.icon}
                  size={config.icon}
                  strokeWidth={1.5}
                  className="text-white"
                />
              </div>
            )}
            <h5 className="card-title mb-0">{item.item.title}</h5>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Badge bg="rounded-pill bg-danger text-white">{item.amount}x</Badge>
          </div>
        </div>

        {item.item.description && (
          <p className="card-text small mb-0 mt-4">{item.item.description}</p>
        )}
      </Card.Body>
    </Card>
  );
}
